import { render, staticRenderFns } from "./ReferenceDisplay.vue?vue&type=template&id=927aa9be&"
import script from "./ReferenceDisplay.vue?vue&type=script&lang=js&"
export * from "./ReferenceDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports